import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import * as _ from 'lodash';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectClaimTypes } from 'containers/ClaimList/selectors';
import injectReducer from 'utils/injectReducer';
import AsyncButton from 'components/AsyncButton';
import { makeSelectProgressBarStatus } from 'containers/ProgressBar/selectors';
import { makeSelectClaimId } from 'containers/ClaimList/selectors';

import { makeSelectStepDeclaration } from './selectors';
import reducer from './reducer';
import messages from './messages';
import Section from '../components/Section';
import { handleFormDataChange } from './actions';
import ControlContainer from '../components/ControlContainer';
import OutlineButton from '../components/Button/OutlineButton';
import P from '../../../components/P/index';
import { saveFormData, submitClaim, submitClaimFail, downloadClaimSummaryPdf, downloadOnlineElectronicConsent, validateClaimParent } from '../actions';
import {
  makeSelectCurrentStep,
  makeSelectNoBenefitError,
  makeSelectSteps,
  makeSelectWizardSteps,
  makeSelectValidateClaim,
} from '../../Wizard/selectors';
import ModalNotice from './components/ModalNotice';
import ModalNoBenefit from './components/ModalNoBenefit';
import SubmitClaim from './components/SubmitClaim';
import { appConfig } from './../../../configureApp';
import { makeSelectStepWhatHappened } from '../StepWhatHappened/selectors';
import { makeSelectStepSupportingDocuments } from '../StepSupportingDocuments/selectors';
import { makeSelectStepClaimSummary } from '../StepClaimSummary/selectors';
import { makeSelectStepTripCancellationAndTripInterruption } from '../StepTripCancellationAndTripInterruption/selectors';
import { makeSelectStepOther } from '../StepOther/selectors';
import {
  makeSelectShowElectronicConsentDocument,
  makeSelectEmailAddressLogin,
  makeSelectDeclarationClaimsAdminCompanyName,
  makeSelectTPAName,
  makeSelectCarrier,
  makeSelectInsuredsList,
  makeSelectIsClaimGroupAllowed,
  makeSelectIsClaimForFieldEnabled, 
  makeSelectCellCaptiveName,
  makeSelectJSONVersion,
  makeSelectShowInsuredMultiClaimant,
} from '../../App/selectors';
import toastr from 'toastr';

import { LIST_CELLCAPTIVE_NAME } from '../../App/constants';
class StepDeclaration extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clickedItemId: '',
      submitButtonId: _.uniqueId(),
      showError: false,
      exporting: false,
      submitting: false,
      showModal: false,
      errorEmails: null,
    };
    this.checkError = this.checkError.bind(this);
    this.exportPdf = this.exportPdf.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, submitted } = this.props;
    const { signature } = this.props.form;
    if (!nextProps.loading) {
      this.setState({ clickedItemId: '' });
    }
    if (nextProps.currentStep !== currentStep && currentStep === step && submitted === false) {
      this.props.onFormDataChange('form.signature', false);
      this.setState({ showError: false });
    }
  }

  isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (propertyName === 'form.emailAddress') {
      if (!this.isValidEmail(value)) {
        this.setState({ errorEmails: 'Email is invalid' });
      } else {
        this.setState({ errorEmails: null });
      }
    }
    if (propertyName === 'form.electronicConsentDocument') {
      if (value === 'false') {
        this.props.onFormDataChange('form.electronicConsentDocument', '');
      }
    }
    if (propertyName === 'form.signature' || propertyName === 'form.declarationSignature') {
      if (value === true) {
        this.props.onValidateClaim();
        if (!this.checkError()) {
          this.setState({ showError: false });
        } else {
          this.setState({ showError: true });
        }
      }
    }
    this.props.onFormDataChange(propertyName, value);
  };
  handleDownload = () => () => {
    this.props.OnDownLoadDocFile();
  };
  handleDayChange = (propertyName) => (day) => {
    const localDate = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, localDate);
  };
  handleClick = (event) => {
    if (!this.checkError()) {
      const target = event.currentTarget || event.srcElement;
      this.setState({
        clickedItemId: target.id,
        submitting: true,
      });
      // this.generatePdf((pdf) => {
      //   if (pdf) {
      //     const blob = pdf.output('blob');
      //     this.props.onFormSubmit(blob);
      //   }
      //   this.setState({ submitting: false });
      // });
      this.props.onFormSubmit();
      this.setState({ submitting: false });
    } else {
      this.setState({ showError: true });
      toastr.error('Please fix the errors in the form before submitting your claim.');
    }
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  checkError() {
    const { wizardSteps, stepSupportingDocumentsData, stepClaimSummaryData } = this.props;
    const showWarningMissingRequiredDocument = stepSupportingDocumentsData.showWarningMissingRequiredDocument;
    const showWarningInvalidRequiredDocument = stepSupportingDocumentsData.showWarningInvalidRequiredDocument;
    const showWarningRequiredDocument = showWarningMissingRequiredDocument || showWarningInvalidRequiredDocument;

    const isDocumentValidationProcessing = stepSupportingDocumentsData.validationMessages.length > 0 && stepSupportingDocumentsData.validationMessages.some((m) => m.Message === null && m.Success === null);
    if (isDocumentValidationProcessing) {
      toastr.error('Document validation is in progress. Please wait until it is completed or cancel the validation.');
      return true;
    }

    const steps = showWarningRequiredDocument ?
      wizardSteps.filter((x) => {
        if (x.name === 'StepSupportingDocuments') return false;
        if (x.name === 'StepClaimSummary' && stepClaimSummaryData.validated) return false;
        return true;
      })
      : wizardSteps;
    return _.some(steps, (section) => section.error === true);
  }

  exportPdf() {
    this.setState({ exporting: true });
    this.showModal();
    const cb = () => {
      this.closeModal();
      this.setState({ exporting: false });
    };
    this.props.downloadClaimSummaryPdf(cb);
  }

  showSpinnerForElement = (elementId) => this.state.clickedItemId === elementId;

  closeModal() {
    this.setState({ showModal: false });
  }

  showModal() {
    this.setState({ showModal: true });
  }
  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
  };

  renderPrivacyStatement() {
    return (
      <Section>
        <ControlContainer>
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.privacyStatement} />
          </P>
          <P style={{ fontStyle: 'italic' }}>
            <FormattedMessage {...messages.privacyStatementMessage} values={{ link: appConfig.privacyStatementUrl }} />
          </P>
        </ControlContainer>
      </Section>
    );
  }

  renderNotice() {
    this.props.adjust();
    return (
      <div
        style={{
          color: '#fff',
          backgroundColor: '#ed1c24',
          textAlign: 'center',
          padding: 3,
        }}
      >
        <FormattedMessage {...messages.errorNotice} />
      </div>
    );
  }


  render() {
    const { signature, emailAddress, electronicConsentDocument, declarationSignature, privacyActAuthorisationSignature, warningMissingRequiredDocument } = this.props.form;
    const {
      submitted,
      loading,
      noBenefitError,
      onCloseModal,
      wizardStepNames,
      showElectronicConsentDocument,
      FNOLDeclarationClaimsAdminCompanyName,
      emailAddressLogin,
      isSummary,
      validateClaim,
      TPAName,
      carrier,
      intl,
      isClaimForFieldEnabled,
      stepSupportingDocumentsData,
      cellCaptiveName,
      showInsuredMultiClaimant,
      jsonVersion,
    } = this.props;
    const { submitButtonId, showError, submitting, showModal, errorEmails } = this.state;
    const waitInterval = 5 * 1000;
    const deboundceSubmitClick = _.debounce(this.handleClick,
      waitInterval,
      {
        maxWait: waitInterval,
        leading: true,
        trailing: false,
      });
    if (emailAddress === '' && showElectronicConsentDocument) {
      this.props.onFormDataChange('form.emailAddress', emailAddressLogin);
    }
    const showWarningMissingRequiredDocument = stepSupportingDocumentsData.showWarningMissingRequiredDocument;
    const showWarningInvalidRequiredDocument = stepSupportingDocumentsData.showWarningInvalidRequiredDocument;
    const showWarningRequiredDocument = showWarningMissingRequiredDocument || showWarningInvalidRequiredDocument;
    let isSubmitted = electronicConsentDocument === null ? true : (!submitted && signature === true && !submitting);
    isSubmitted = showWarningRequiredDocument === false ? isSubmitted : (!submitted && signature === true && !submitting && warningMissingRequiredDocument === 'true');
    const noneSureGoSubmitted = showWarningRequiredDocument === false ? (submitted || !signature === true || submitting || !validateClaim) : (submitted || !signature === true || submitting || !validateClaim || warningMissingRequiredDocument !== 'true');
    const sctiSubmitted = privacyActAuthorisationSignature && declarationSignature;
    const isVisitorsToCanada = cellCaptiveName === LIST_CELLCAPTIVE_NAME.CELL_CAPTIVE_NAME_VISITORS_TO_CANADA;
    const enabledClaimSplitFeature = jsonVersion >= 17 && isClaimForFieldEnabled;
    const showInsuredMultiClaimantTrawick = enabledClaimSplitFeature && isClaimForFieldEnabled && appConfig.reactAppEnv === 'trawick';
    return (
      <div className="app-content">
        {showError && this.renderNotice()}

        <SubmitClaim
          signature={signature}
          emailAddress={emailAddress}
          electronicConsentDocument={electronicConsentDocument}
          FNOLDeclarationClaimsAdminCompanyName={FNOLDeclarationClaimsAdminCompanyName}
          TPAName={TPAName}
          carrier={carrier}
          errorEmails={errorEmails}
          handleDownload={this.handleDownload}
          showElectronicConsentDocument={showElectronicConsentDocument}
          submitted={submitted}
          handleChange={this.handleChange}
          stepWhatHappenedData={this.props.stepWhatHappenedData}
          stepTripCancellationAndTripInterruptionData={this.props.stepTripCancellationAndTripInterruptionData}
          stepOtherData={this.props.stepOtherData}
          insuredsList={this.props.insuredsList}
          isClaimGroupAllowed={this.props.isClaimGroupAllowed}
          declarationSignature={declarationSignature}
          privacyActAuthorisationSignature={privacyActAuthorisationSignature}
          isClaimForFieldEnabled={enabledClaimSplitFeature}
          warningMissingRequiredDocument={warningMissingRequiredDocument}
          showWarningMissingRequiredDocument={showWarningMissingRequiredDocument}
          showWarningInvalidRequiredDocument={showWarningInvalidRequiredDocument}
          isVisitorsToCanada={isVisitorsToCanada}
          showInsuredMultiClaimant={showInsuredMultiClaimant}
        >
        </SubmitClaim>
        {showError && this.renderNotice()}

        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className={`${appConfig.reactAppEnv === 'scti' ? 'base-button back-button' : 'btn-outline'}`}
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.back' })}
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  {/* <OutlineButton onClick={this.printClaimSummary}>Print Claim Summary</OutlineButton> */}
                  <AsyncButton
                    id="export-btn"
                    className="btn-outline"
                    loading={this.state.exporting}
                    spinner={this.state.exporting}
                    onClick={this.exportPdf}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.downloadSummary' })}
                  </AsyncButton>
                </div>
                {!submitted && <div className={'col-12 col-sm-auto'}>

                  <AsyncButton
                    id={this.saveButtonId}
                    disabled={submitted}
                    className="btn-outline"
                    loading={loading}
                    spinner={this.showSpinnerForElement(this.saveButtonId)}
                    onClick={this.handleSaveButtonClick}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.save' })}
                  </AsyncButton>
                </div>}
              </div>
            </div>
            {(showElectronicConsentDocument === true && validateClaim) &&
              <div className={'col-12 col-sm-auto'}>
                <AsyncButton
                  id={submitButtonId}
                  className={!isSubmitted || submitted ? 'btn-action-disable' : 'btn-outline'}
                  loading={loading || submitting}
                  spinner={this.showSpinnerForElement(submitButtonId)}
                  onClick={deboundceSubmitClick}
                  disabled={!isSubmitted || submitted}
                  onKeyDown={this.handleKeyDown}
                >
                  {intl.formatMessage({ id: 'fastCover.button.submitClaim' })}
                </AsyncButton>
              </div>
            }
            {(showElectronicConsentDocument === true && !validateClaim) &&
              <div className={'col-12 col-sm-auto'}>
                <AsyncButton
                  id={submitButtonId}
                  className={'btn-action-disable'}
                  loading={loading || submitting}
                  spinner={this.showSpinnerForElement(submitButtonId)}
                  onClick={deboundceSubmitClick}
                  disabled={!validateClaim || submitted}
                  onKeyDown={this.handleKeyDown}
                >
                  {intl.formatMessage({ id: 'fastCover.button.submitClaim' })}
                </AsyncButton>
              </div>
            }
            {(isVisitorsToCanada || (showElectronicConsentDocument === false && showInsuredMultiClaimantTrawick)) &&
              <div className={'col-12 col-sm-auto'}>
                <AsyncButton
                  id={submitButtonId}
                  className={noneSureGoSubmitted ? 'btn-action-disable' : 'btn-outline'}
                  loading={loading || submitting}
                  spinner={this.showSpinnerForElement(submitButtonId)}
                  onClick={deboundceSubmitClick}
                  disabled={noneSureGoSubmitted}
                  onKeyDown={this.handleKeyDown}
                >
                  {intl.formatMessage({ id: 'fastCover.button.submitClaim' })}
                </AsyncButton>
              </div>
            }
            {(showElectronicConsentDocument === false && (!showInsuredMultiClaimantTrawick && isClaimForFieldEnabled && !isVisitorsToCanada)) &&
              <div className={'col-12 col-sm-auto'}>
                <AsyncButton
                  id={submitButtonId}
                  className={!sctiSubmitted ? 'btn-action-disable' : 'btn-outline'}
                  loading={loading || submitting}
                  spinner={this.showSpinnerForElement(submitButtonId)}
                  onClick={deboundceSubmitClick}
                  disabled={!sctiSubmitted || submitted}
                  onKeyDown={this.handleKeyDown}
                >
                  {intl.formatMessage({ id: 'fastCover.button.submitClaim' })}
                </AsyncButton>
              </div>
            }
          </div>)
        }
        {!isSummary && (<ModalNotice isOpen={showModal} onClose={this.closeModal} />)}
        {!isSummary && (<ModalNoBenefit
          isOpen={noBenefitError}
          activeSections={wizardStepNames}
          onClose={onCloseModal}
        />)}
      </div>
    );
  }
}

StepDeclaration.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  OnDownLoadDocFile: PropTypes.func,
  prev: PropTypes.func,
  onFormSubmit: PropTypes.func,
  loading: PropTypes.bool,
  currentStep: PropTypes.number,
  step: PropTypes.number,
  wizardSteps: PropTypes.array,
  adjust: PropTypes.func,
  submitted: PropTypes.bool,
  noBenefitError: PropTypes.bool,
  onCloseModal: PropTypes.func,
  wizardStepNames: PropTypes.array,
  downloadClaimSummaryPdf: PropTypes.func,
  onFormDataSave: PropTypes.func,
  stepWhatHappenedData: PropTypes.any,
  stepTripCancellationAndTripInterruptionData: PropTypes.any,
  stepOtherData: PropTypes.any,
  showElectronicConsentDocument: PropTypes.bool,
  FNOLDeclarationClaimsAdminCompanyName: PropTypes.any,
  cellCaptiveName: PropTypes.any,
  TPAName: PropTypes.any,
  carrier: PropTypes.any,
  emailAddressLogin: PropTypes.any,
  isSummary: PropTypes.bool,
  validateClaim: PropTypes.bool,
  onValidateClaim: PropTypes.func,
  insuredsList: PropTypes.any,
  isClaimGroupAllowed: PropTypes.bool,
  isClaimForFieldEnabled: PropTypes.bool,
  showInsuredMultiClaimant: PropTypes.bool,
  stepSupportingDocumentsData: PropTypes.any,
  stepClaimSummaryData: PropTypes.any,
  jsonVersion: PropTypes.string,
  intl: intlShape.isRequired,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepDeclaration(),
  loading: makeSelectProgressBarStatus(),
  wizardSteps: makeSelectSteps(),
  currentStep: makeSelectCurrentStep(),
  claimId: makeSelectClaimId(),
  noBenefitError: makeSelectNoBenefitError(),
  validateClaim: makeSelectValidateClaim(),
  claimTypes: makeSelectClaimTypes(),
  wizardStepNames: makeSelectWizardSteps(),
  stepWhatHappenedData: makeSelectStepWhatHappened(),
  stepTripCancellationAndTripInterruptionData: makeSelectStepTripCancellationAndTripInterruption(),
  stepOtherData: makeSelectStepOther(),
  showElectronicConsentDocument: makeSelectShowElectronicConsentDocument(),
  FNOLDeclarationClaimsAdminCompanyName: makeSelectDeclarationClaimsAdminCompanyName(),
  TPAName: makeSelectTPAName(),
  carrier: makeSelectCarrier(),
  emailAddressLogin: makeSelectEmailAddressLogin(),
  insuredsList: makeSelectInsuredsList(),
  isClaimGroupAllowed: makeSelectIsClaimGroupAllowed(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  showInsuredMultiClaimant: makeSelectShowInsuredMultiClaimant(),
  stepSupportingDocumentsData: makeSelectStepSupportingDocuments(),
  stepClaimSummaryData: makeSelectStepClaimSummary(),
  cellCaptiveName: makeSelectCellCaptiveName(),
  jsonVersion: makeSelectJSONVersion(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormSubmit: () => dispatch(submitClaim()),
  OnDownLoadDocFile: () => dispatch(downloadOnlineElectronicConsent()),
  onFormDataSave: () => dispatch(saveFormData()),
  onCloseModal: () => dispatch(submitClaimFail(false)),
  downloadClaimSummaryPdf: (cb) => dispatch(downloadClaimSummaryPdf(cb)),
  onValidateClaim: () => dispatch(validateClaimParent()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({
  key: 'stepDeclaration',
  reducer,
});

export default compose(
  withReducer,
  withConnect,
  injectIntl
)(StepDeclaration);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/index.js